import React from "react";


const Skeleton = ({type, i = 1}) => {

    if (type === 'TableLoader') {
        return (
            <>
                <div
                    className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 sm:px-0 h-auto"}>
                    <div className=" shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                    <div className=" shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                    <div className=" shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                    <div className=" shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"grid grid-cols-1 mt-8"}>
                    <div className="shadow rounded-md p-4 w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="space-y-8">
                                    <div className="grid grid-cols-4 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
    }

    if (type === 'OtherMainLoader') {
        return (<>
            <div className={"container mx-auto mt-10"}>
                <div className={"grid grid-cols-4 mt-8 gap-4"}>
                    <div className="border border-slate-300 shadow rounded-md p-4 w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="space-y-8">
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-2"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                    <div className="h-5 bg-slate-300 rounded"></div>
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className=" col-span-3 border border-slate-300 shadow rounded-md p-4 w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="space-y-8">
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-2"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                    <div className="h-5 bg-slate-300 rounded"></div>
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }

    if (type === "ChartLoader") {
        return (<>
            <div className={"container mx-auto mt-10"}>
                <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 sm:px-0"}>
                    <div className="border border-slate-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="rounded bg-slate-300 h-5 w-5"></div>
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                    <div className="border border-slate-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="rounded bg-slate-300 h-5 w-5"></div>
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                    <div className="border border-slate-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="rounded bg-slate-300 h-5 w-5"></div>
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                    <div className="border border-slate-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="rounded bg-slate-300 h-5 w-5"></div>
                            <div className="flex-1 space-y-6">
                                <div className="h-5 bg-slate-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"grid grid-cols-1 mt-8"}>
                    <div className="border border-slate-300 shadow rounded-md p-4 w-full mx-auto">
                        <div className="animate-pulse flex space-x-4">
                            <div className="flex-1 space-y-6">
                                <div className="space-y-8">
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-2"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                    </div>
                                    <div className="h-5 bg-slate-300 rounded"></div>
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="h-5 bg-slate-300 rounded col-span-1"></div>
                                        <div className="h-5 bg-slate-300 rounded col-span-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }

    if (type === 'BulletinLoader') {
        return (<>
            <div
                className="p-2 max-w-sm w-full mx-auto">
                <div className="animate-pulse flex space-x-4">
                    <div className="flex-1 space-y-6">
                        <div className="h-5 bg-slate-300 rounded"></div>
                    </div>
                </div>
            </div>
        </>)
    }

    if (type === 'financeHomeButtonLoader') {
        return (<>
            {[...Array(i)].map((x, j) =>
                <div key={j} className="h-48 border border-slate-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
                    <div className="animate-pulse flex space-x-4">
                        <div className="flex-1 space-y-6">
                            <div className="h-40 bg-slate-100 rounded"></div>
                        </div>
                    </div>
                </div>
            )}

        </>)
    }

    return (<></>)

};

export default Skeleton;